Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _object_spread = require("@swc/helpers/_/_object_spread");
var createScriptLocator = (entryUrl, config)=>_async_to_generator._(function*() {
        if (typeof config === 'function') {
            var locator = yield config(entryUrl);
            return locator;
        }
        if (typeof config === 'object') {
            return _object_spread._({
                url: entryUrl
            }, config);
        }
        return {
            url: entryUrl
        };
    })();
var getPublicPath = (url)=>{
    return url.split('/').slice(0, -1).join('/');
};
var getAssetPath = (url)=>{
    var assetPath = url.split(getPublicPath(url))[1];
    // normalize by removing leading slash
    return assetPath.startsWith('/') ? assetPath.slice(1) : assetPath;
};
var rebaseRemoteUrl = (from, to)=>{
    var assetPath = getAssetPath(from);
    var publicPath = getPublicPath(to);
    return [
        publicPath,
        assetPath
    ].join('/');
};
var registerResolver = (remoteInfo, config)=>_async_to_generator._(function*() {
        // when manifest is used, the valid entry URL comes from the version field
        // otherwise, the entry URL comes from the entry field which has the correct publicPath for the remote set
        var entryUrl;
        if ('version' in remoteInfo && remoteInfo.version) {
            entryUrl = remoteInfo.version;
        } else if ('entry' in remoteInfo) {
            entryUrl = remoteInfo.entry;
        }
        if (!entryUrl) {
            throw new Error('[RepackResolverPlugin] Cannot determine entry URL for remote: ' + remoteInfo.name);
        }
        var resolver = (scriptId, caller, referenceUrl)=>_async_to_generator._(function*() {
                if (scriptId === remoteInfo.name || caller === remoteInfo.name) {
                    // referenceUrl should always be present and this should never happen
                    if (!referenceUrl) {
                        throw new Error('[RepackResolverPlugin] Reference URL is missing');
                    }
                    var url = rebaseRemoteUrl(referenceUrl, entryUrl);
                    var locator = yield createScriptLocator(url, config);
                    return locator;
                }
            })();
        var runtime = __webpack_require__.repack.shared;
        if (runtime.scriptManager) {
            runtime.scriptManager.addResolver(resolver, {
                key: remoteInfo.name
            });
        } else {
            runtime.enqueuedResolvers.push([
                resolver,
                {
                    key: remoteInfo.name
                }
            ]);
        }
    })();
var RepackResolverPlugin = (config)=>({
        name: 'repack-resolver-plugin',
        registerRemote: (args)=>{
            registerResolver(args.remote, config);
            return args;
        }
    });
var _default = RepackResolverPlugin;
